import React from 'react';
import { Spinner } from 'react-bootstrap';

const LoadingFallback = () => {
    return (
        <div
            className={'loading-fallback'}>
            <Spinner
                animation={'border'}
                role={'status'}>
                <span
                    className={'visually-hidden'}>Loading...</span>
            </Spinner>
        </div>
    );
};

export default LoadingFallback;